export default "__VITE_ASSET__1bacae93__$_?component__"